import Typography from '@mui/material/Typography';
import React, { useRef } from 'react';
import { IconFormIcons, Plus16 } from 'shared/assets/icons';
import { LifeAreaContextMenu } from 'shared/components/connected/life-area-context-menu';
import { Icon } from 'shared/components/ui/icon';
import { IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useOpenCreateTask } from 'shared/contexts/task-detail';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { Paths } from 'shared/routes';
import { LifeArea } from 'shared/types/life-area';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

import * as Styled from './favorite-life-area.style';

export type FavoriteLifeAreaProps = {
  lifeArea: LifeArea;
  currentPath?: string;
  isMoving?: boolean;
};

export const FavoriteLifeArea: React.FC<FavoriteLifeAreaProps> = ({
  lifeArea,
  currentPath,
  isMoving,
}) => {
  const containerRef = useRef<HTMLAnchorElement>(null);
  const url = replaceUrlParams(Paths.LifeAreaDetail, { id: lifeArea.id });
  const isActive = !!currentPath && currentPath.includes(url);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const openCreateTask = useOpenCreateTask();

  const onCreateTask = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openCreateTask({ lifeAreaId: lifeArea.id });
  };

  return (
    <>
      <Styled.Link
        to={url}
        $active={isActive}
        as={lifeArea.frozenAt ? 'span' : undefined}
        $isFrozen={!!lifeArea.frozenAt}
        $isMoving={!!isMoving}
        ref={containerRef}
        onContextMenu={!lifeArea.frozenAt ? openMenu : undefined}
      >
        <Styled.IconContainer $active={isActive} $color={lifeArea.color}>
          <Icon icon={IconFormIcons[lifeArea.iconName]} />
        </Styled.IconContainer>
        <Styled.Title>
          <Typography variant="body2" component="span">
            {lifeArea.name}
          </Typography>
        </Styled.Title>
        <Styled.IconButtonContainer>
          <IconButton onClick={onCreateTask} icon={Plus16} size={Sizes.Small} />
        </Styled.IconButtonContainer>
      </Styled.Link>
      {menuOpen && (
        <LifeAreaContextMenu
          lifeArea={lifeArea}
          onClose={closeMenu}
          referenceElement={containerRef}
        />
      )}
    </>
  );
};
